import template from './account-page.html';
import controller from './account-page.controller';

export default {
	template,
	bindings: {
		icon: '@',
		type: '@',
		tooltip: '@',

		invertDir: '<?',
		isOpen: '=?',
		isLoading: '<',

		onAdd: '&?',
		onRefresh: '&?',
	},
	transclude: {
		body: '?accountPageBody',
	},
	controller,
};
